module.exports = __webpack_public_path__ + "static/media/image-card-6.9c803ff2.png";